export default class ImagePositionKitchen
{
    constructor() {
        this.x = 49;
        this.y = 41;
        this.width = 341;
        this.height = 479;
        this.src = '/wp-content/themes/orchid-store-kc/assets/dist/img/frame/backgrounds/kitchen.jpg';
    }
}
